<template>
  <v-checkbox hide-details style="height: 24px;width: 24px;" readonly v-model="value" :color="color">
  </v-checkbox>
</template>

<style scoped>

</style>

<script>
  import CheckboxCell from "./checkboxCell.ts";
  export default CheckboxCell;
</script>